import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  FaFacebookF,
  FaLinkedinIn,
  FaTwitter,
  FaBehance,
  FaYoutube,
  FaPhoneAlt,
} from "react-icons/fa";
import './Footer.css'
import { MdMail } from "react-icons/md";
import { useDarkMode } from "../../contexts/DarkModeContext";
import { fetchAppSettings } from "../../redux/slices/appSettingsSlice";

function Footer() {
  const { isDarkMode } = useDarkMode();
  const dispatch = useDispatch();
  const { settings } = useSelector((state) => state.appSettings);

  // Fetch app settings on component mount
  useEffect(() => {
    dispatch(fetchAppSettings());
  }, [dispatch]);

  return (
    <footer className={`footer ${isDarkMode ? 'dark-mode' : 'light-mode'}`}>
      <div className="container">
        <div className="row text-end">
        <div className="col-md-3 footer-col">
            <div className="footer-logo">
              <img style={{width : "150px"}} src="/3almnyLogo.png" alt="logo" />
            </div>
            <p className="footer-desc">
              أكاديميتنا العملية تهدف إلى تزويد المتعلمين بالمهارات العملية والتطبيقية التي تؤهلهم لسوق العمل من خلال برامج تدريبية متطورة وتجربة تعليمية تفاعلية.
            </p>
            <p className="footer-contact"><MdMail className="footer-icon" /> 3almny@support.com</p>
            <p className="footer-contact"><FaPhoneAlt className="footer-icon" /> {settings?.phone || '755.002.3005.905'}</p>
          </div>
          <div className="col-md-3 footer-col">
            <h5 className="footer-title">روابط سريعة</h5>
            <ul className="footer-links">
              <li>الرئيسية</li>
              <li>التخصص</li>
              <li>المدرسين</li>
              <li>المواد</li>
              <li>سؤال وجواب</li>
              <li>الاختبارات</li>
            </ul>
          </div>

          <div className="col-md-3 footer-col">
            <h5 className="footer-title">حسابي</h5>
            <ul className="footer-links">
              <li>تواصل معنا</li>
              <li>سياسة الخصوصية</li>
              <li>الشروط والأحكام</li>
            </ul>
          </div>

          <div className="col-md-3 footer-col">
            <h5 className="footer-title">التواصل الاجتماعي</h5>
            <ul className="footer-links">
              <li><FaFacebookF className="footer-icon" /> Facebook</li>
              <li><FaLinkedinIn className="footer-icon" /> Linkedin</li>
              <li><FaTwitter className="footer-icon" /> Twitter</li>
              <li><FaBehance className="footer-icon" /> Behance</li>
              <li><FaYoutube className="footer-icon" /> YouTube</li>
            </ul>
          </div>

         
        </div>

        <hr className="footer-divider" />

        <div className="text-center footer-bottom">
          حقوق النشر © 2025 جميع الحقوق محفوظة. مدعوم من <span className="footer-brand">برمجة تك</span>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
